import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { EXPERIMENTS_SET_ACTIVE } from 'redux/actionTypes/experiments';
var setActiveExperiment = function setActiveExperiment(experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var activeExperimentId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            activeExperimentId = getState().experiments.meta.activeExperimentId;
            if (!(activeExperimentId === experimentId)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", null);
          case 3:
            dispatch({
              type: EXPERIMENTS_SET_ACTIVE,
              payload: {
                experimentId: experimentId
              }
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default setActiveExperiment;